import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Button, Col, Form, Input, message, Row, Select, Spin, Badge, Avatar, Modal, DatePicker } from "antd";
import { CSVLink } from "react-csv";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import Styled from "styled-components";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import moment from "moment";
import { CALL_API } from "../../../Common/api";
import { StyledTable } from "../../../Reusablecomponents/UITable/UITable";
import UIModal from "../../../Reusablecomponents/UIModal";
import { ButtonFilled, Buttontransparent } from "../../../Reusablecomponents/UIButtons";
import ReusablePagination from "../../../Reusablecomponents/ReusablePagination";
import filtericon from "../../../assets/images/filter-svgrepo-com (1).svg";
import ExportIcon from "../../../assets/images/export-svgrepo-com (1).svg";
import { ReactComponent as Indicator } from "../../../assets/images/Indicator.svg";
import { ReactComponent as Chat } from "../../../assets/images/Chat.svg";
import { convertUTCToLocal } from "../../../utils/helper";
import { fetchNexusAssets, fetchNexusFences } from "../../TrackRightAI/nexusTrakingApi";
import { withNexusReportShell } from "../NexusReportShell";

dayjs.extend(utc);
dayjs.extend(timezone);

// Nexus KPI Report: same page as the AI KPI Report, over the Nexus KPI alerts
// raised by the scheduler (POST nexus/kpialerts, nexus/kpiresolve,
// nexus/kpibulkresolve).

const { Option } = Select;
const { RangePicker } = DatePicker;

const Wrappercontainer = Styled.div`
  .customizable_container_forkpi {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
  }
  p {
    padding: 10px 4px 10px 4px;
    margin: 4px 0px 4px 0px;
    font-size: 18px;
    font-weight: 400;
    color: black;
  }
  .customizable_container {
    width: 30%;
    background-color: white;
    align-items: center;
    display: flex;
    flex-direction: column;
    border-radius: 12px;
    box-shadow: 2px 2px 5px rgb(232, 235, 240), 5px 5px 10px rgb(232, 235, 240),
      5px 5px 10px rgb(232, 235, 240);
  }
  .resolve_btn:hover {
    background-color: green !important;
    color: white !important;
  }
  .ant-select-selector {
    border-radius: 18px;
  }
  .modal_container_forfiltermenu {
    display: flex;
    justify-content: space-between;
    margin: 7px 14px 07px 0px;
  }
  .flilter_five {
    margin: 0px;
  }
  .cancel_btn_forpopup_two {
    background-color: rgb(232, 255, 236);
    color: green;
  }
`;

const Styledashboard = Styled.div`
  .resolve_btn:hover {
    background-color: green !important;
    color: white !important;
  }
  .head {
    margin-bottom: 5px;
    color: #5f6d8c;
    height: 29px;
    font-size: 16px;
    font-weight: 400;
  }
  .header-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }
  .kpialerts {
    color: rgb(228, 164, 0);
    font-size: 16px;
    font-weight: 500;
  }
  .Resolved {
    color: green;
    font-size: 16px;
    font-weight: 500;
  }
  .UnResolved {
    color: red;
    font-size: 16px;
    font-weight: 500;
  }
  .values {
    color: #363636;
    font-size: 32px;
    font-weight: 600;
  }
  .customizable_container {
    width: 30%;
    height: 139px;
    background-color: white;
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    margin-bottom: 20px;
    border-radius: 12px;
    box-shadow: 2px 2px 5px rgb(232, 235, 240), 5px 5px 10px rgb(232, 235, 240),
      5px 5px 10px rgb(232, 235, 240);
  }
  .customizable_container_forkpi {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    margin-top: 20px;
  }
  .text-wrap {
    white-space: normal;
    word-break: normal;
    overflow-wrap: break-word;
    line-height: 1.4;
  }
  .compact-col {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    min-width: 150px;
    max-width: 180px;
    transition: max-width 0.2s ease;
  }
  .compact-col.expanded {
    justify-content: flex-start;
    max-width: 250px;
  }
`;

const Duration = [
  { label: "Current Month", value: "current_month" },
  { label: "Current Year", value: "current_year" },
  { label: "Last Month", value: "last_month" },
  { label: "Today", value: "today" },
];

const rangeFor = (duration) => {
  if (duration === "today") return [dayjs(), dayjs()];
  if (duration === "last_month")
    return [dayjs().subtract(1, "month").startOf("month"), dayjs().subtract(1, "month").endOf("month")];
  if (duration === "current_year") return [dayjs().startOf("year"), dayjs().endOf("year")];
  return [dayjs().startOf("month"), dayjs().endOf("month")];
};

const formattedTime = (minutes) => dayjs().startOf("day").add(minutes || 0, "minute").format("HH:mm");
const formattedDifferentTime = (totalMinutes) => {
  const absMinutes = Math.abs(totalMinutes || 0);
  const hours = Math.floor(absMinutes / 60);
  const minutes = absMinutes % 60;
  return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}`;
};

const KpiReports = () => {
  const location = useLocation();
  const navState = location.state || {};
  const userInfo = useSelector((state) => state?.authTracking?.userInfo);
  const transporterList = useSelector((state) => state?.authTracking?.transporterList);
  const reduxPermissions = useSelector((state) => state?.authTracking?.myPermissionList || {});
  const can = (code) => Array.isArray(reduxPermissions?.NE_KPIRPT) && reduxPermissions.NE_KPIRPT.includes(code);
  const exportAllowed = useMemo(() => can("EX"), [reduxPermissions]); // eslint-disable-line react-hooks/exhaustive-deps
  const resolveAllowed = useMemo(() => can("BR"), [reduxPermissions]); // eslint-disable-line react-hooks/exhaustive-deps

  // arriving from the dashboard's Attention panel: that day, unresolved, that KPI
  const getInitialValues = () => {
    let daterange = rangeFor("current_month");
    if (navState.date) {
      const d = navState.date?.$isDayjsObject ? dayjs(navState.date.$d) : dayjs(navState.date);
      daterange = [d, d];
    }
    return {
      Name: navState.Name || "",
      FNAME: "",
      CustName: navState.consignor || "",
      Shipper: "",
      duration: navState.date ? undefined : "current_month",
      daterange,
      code: "",
      Status: navState.label === "Unresolved" ? "0" : navState.label === "Resolved" ? "1" : "",
      REGNO: "",
    };
  };

  const [filterform] = Form.useForm();
  const [filterCount, setFilterCount] = useState(0);
  const [filterModalOpen, setFilterModalOpen] = useState(false);
  const [filterValues, setFilterValues] = useState(getInitialValues);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [loading, setLoading] = useState(false);
  const [report, setReport] = useState({ data: [], total: 0, summary: {} });
  const [tableSort, setTableSort] = useState({ field: null, order: null });
  const [CSVList, setCSVList] = useState([]);
  const [CSVLoader, setCSVLoader] = useState(false);
  const csvLinkEl = useRef();
  const [Hoveredrow, setHoveredRow] = useState(null);
  const [modalType, setModalType] = useState(null); // "view" | "resolve"
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [resolveModal, setResolveModal] = useState(false);

  const [vehicles, setVehicles] = useState([]);
  const [consignors, setConsignors] = useState([]);
  const [consignees, setConsignees] = useState([]);
  useEffect(() => {
    fetchNexusAssets()
      .then((r) => setVehicles(r.response || []))
      .catch(() => setVehicles([]));
    if (userInfo?.MCID === 59 || !userInfo?.NexusCompId) return;
    fetchNexusFences("Consignor", userInfo.NexusCompId).then(setConsignors).catch(() => setConsignors([]));
    fetchNexusFences("Consignee", userInfo.NexusCompId).then(setConsignees).catch(() => setConsignees([]));
  }, [userInfo?.MCID, userInfo?.NexusCompId]);

  // the filter form shows the preset values (e.g. from the dashboard)
  useEffect(() => {
    filterform.setFieldsValue(filterValues);
    setFilterCount(countFilters(filterValues));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const countFilters = (v) =>
    ["Name", "FNAME", "CustName", "Shipper", "code", "Status", "REGNO"].filter(
      (k) => v?.[k] !== undefined && v?.[k] !== null && v?.[k] !== "",
    ).length;

  const requestBody = useCallback(
    (page, size) => {
      const range = filterValues?.daterange || rangeFor("current_month");
      return {
        dateFrom: dayjs(range[0]).format("YYYY-MM-DD"),
        dateTo: dayjs(range[1]).format("YYYY-MM-DD"),
        page,
        pageSize: size,
        status: filterValues?.Status ?? "",
        kpiName: filterValues?.Name || "",
        vehicle: filterValues?.REGNO || "",
        consignor: filterValues?.CustName || "",
        consignee: filterValues?.FNAME || "",
        transporter: filterValues?.Shipper || "",
        consignCode: filterValues?.code || "",
      };
    },
    [filterValues],
  );

  const fetchReport = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await CALL_API("POST", "nexus/kpialerts", requestBody(currentPage, pageSize));
      setReport({ data: data?.data || [], total: data?.total || 0, summary: data?.summary || {} });
    } catch (error) {
      console.error("[NexusKpiReport] fetch error:", error);
      message.error("Unable to load the KPI report.");
    } finally {
      setLoading(false);
    }
  }, [requestBody, currentPage, pageSize]);

  useEffect(() => {
    fetchReport();
  }, [fetchReport]);

  const handleFilterChange = (field, value) => {
    setCurrentPage(1);
    setFilterValues((prev) => {
      const next = { ...prev, [field]: value };
      setFilterCount(countFilters(next));
      return next;
    });
  };

  const handleDurationChange = (value) => {
    const range = rangeFor(value);
    filterform.setFieldsValue({ duration: value, daterange: range });
    setCurrentPage(1);
    setFilterValues((prev) => ({ ...prev, duration: value, daterange: range }));
  };

  const handleResolve = async () => {
    if (!selectedRecord?.ID) {
      message.error("No KPI selected.");
      return;
    }
    setLoading(true);
    try {
      const res = await CALL_API("POST", "nexus/kpiresolve", {
        ID: selectedRecord.ID,
        MESSAGE: selectedRecord.resolutionComment || "",
      });
      if (res?.ResponseCode === 200) {
        message.success("KPI resolved successfully!");
        setResolveModal(false);
        setSelectedRecord(null);
        fetchReport();
      } else {
        message.error(res?.message || "Unable to resolve the KPI.");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleBulkResolve = async () => {
    setLoading(true);
    try {
      const res = await CALL_API("POST", "nexus/kpibulkresolve", {});
      if (res?.ResponseCode === 200) {
        message.success("KPIs resolved in bulk successfully!");
        fetchReport();
      } else {
        message.error(res?.message || "Unable to resolve the KPIs.");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleresolveclose = () => {
    setResolveModal(false);
    setSelectedRecord(null);
    setModalType(null);
  };

  const isResolved = (r) => r.RESOLVEDBY !== null && r.RESOLVEDBY !== undefined;

  const sortRows = (rows) => {
    if (!tableSort.field) return rows;
    const numeric = ["MAXMINUTES", "DURATION", "diff"];
    return [...rows].sort((a, b) => {
      const av = tableSort.field === "diff" ? (a.DURATION || 0) - (a.MAXMINUTES || 0) : a[tableSort.field];
      const bv = tableSort.field === "diff" ? (b.DURATION || 0) - (b.MAXMINUTES || 0) : b[tableSort.field];
      const r = numeric.includes(tableSort.field)
        ? (Number(av) || 0) - (Number(bv) || 0)
        : String(av ?? "").localeCompare(String(bv ?? ""));
      return tableSort.order === "ascend" ? r : -r;
    });
  };

  const col = (title, dataIndex, render) => ({
    title,
    dataIndex,
    key: dataIndex,
    sorter: true,
    sortOrder: tableSort.field === dataIndex ? tableSort.order : null,
    render,
  });

  const columns1 = [
    col("Date & Time", "CRON", (_, record) => <span>{convertUTCToLocal(record?.CRON)}</span>),
    col("Consign Code", "Code"),
    col("Consignor", "CustName"),
    col("Transporter", "SupName"),
    col("Consignee", "FName"),
    col("KPI Name", "NAME"),
    col("Status", "RESOLVEDBY", (_, record) => (
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        {!isResolved(record) && <Indicator />} {isResolved(record) ? "Resolved" : "Unresolved"}
      </div>
    )),
    col("Target Duration", "MAXMINUTES", (v) => formattedTime(v)),
    col("Actual Duration", "DURATION", (v) => formattedTime(v)),
    col("Difference", "diff", (_, record) => (
      <div style={{ textAlign: "center", lineHeight: 1.5 }}>
        <div>{formattedDifferentTime((record.DURATION || 0) - (record.MAXMINUTES || 0))}</div>
        <div style={{ fontSize: "14px", color: "#888" }}>HH:MM</div>
      </div>
    )),
    col("Resolved by", "USERS", (text) => <div className="text-wrap">{text || "-"}</div>),
    col("Message", "MESSAGE", (text) => <div>{text || "-"}</div>),
    {
      title: "#",
      dataIndex: "x",
      key: "x",
      width: 120,
      render: (text, record) => {
        const isHovered = Hoveredrow === record.key;
        return (
          <div className={`compact-col ${isHovered ? "expanded" : ""}`}>
            {!isHovered ? (
              <span>{text || "-"}</span>
            ) : (
              <>
                <Chat
                  className="cursor-pointer"
                  onClick={() => {
                    setModalType("view");
                    setSelectedRecord(record);
                    setResolveModal(true);
                  }}
                  style={{ fontSize: 18 }}
                />
                {!isResolved(record) && (
                  <Button
                    size="small"
                    style={{ cursor: resolveAllowed ? "pointer" : "not-allowed" }}
                    onClick={() => {
                      if (!resolveAllowed) return;
                      setModalType("resolve");
                      setSelectedRecord(record);
                      setResolveModal(true);
                    }}
                    className="resolve_btn"
                  >
                    Resolve
                  </Button>
                )}
              </>
            )}
          </div>
        );
      },
    },
  ];

  const prepareCSV = async () => {
    try {
      setCSVLoader(true);
      const { data } = await CALL_API("POST", "nexus/kpialerts", requestBody(1, 5000));
      const rows = sortRows(data?.data || []);
      if (!rows.length) {
        message.error("No data available to download.");
        return;
      }
      setCSVList(
        rows.map((item) => ({
          "Date & Time": item.CRON ? convertUTCToLocal(item.CRON) : "-",
          "KPI Name": item.NAME || "",
          "Consign Code": item.Code || "",
          "Trip Code": item.tripcode || "",
          Vehicle: item.vehiclename || "",
          Consignor: item.CustName || "-",
          Transporter: item.SupName || "-",
          Consignee: item.FName || "-",
          Status: isResolved(item) ? "Resolved" : "UnResolved",
          "Actual Duration": formattedTime(item.DURATION),
          "Target Duration": formattedTime(item.MAXMINUTES),
          Difference: formattedDifferentTime((item.DURATION || 0) - (item.MAXMINUTES || 0)),
          "Resolved On": item.RESOLVEDON ? moment(item.RESOLVEDON).format("Do MMM YYYY; hh:mm A") : "-",
          "Resolved By": item.USERS || "",
          Message: item.MESSAGE || "",
        })),
      );
      setTimeout(() => csvLinkEl.current?.link?.click());
    } catch (error) {
      console.error("CSV export error -->", error);
    } finally {
      setCSVLoader(false);
    }
  };

  const s = report.summary || {};

  return (
    <Styledashboard>
      <Row>
        <Col xl={24} sm={24}>
          <div>
            <div className="customizable_container_forkpi">
              <div className="customizable_container">
                <p className="kpialerts">KPI Alerts</p>
                <p className="values">{s.total || 0}</p>
              </div>
              <div className="customizable_container">
                <p className="Resolved">Resolved</p>
                <p className="values">{s.resolved || 0}</p>
              </div>
              <div className="customizable_container">
                <p className="UnResolved">UnResolved</p>
                <p className="values">{s.unresolved || 0}</p>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <div className="header-container">
        <div className="head">{report.total} KPI Alerts</div>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "10px" }}>
          <div>
            <Badge count={filterCount} onClick={() => setFilterModalOpen(true)}>
              <Avatar shape="circle" size="small" src={filtericon} style={{ cursor: "pointer" }} />
            </Badge>
          </div>
          <Spin spinning={CSVLoader}>
            <img
              src={ExportIcon}
              alt="Upload Icon"
              style={{ cursor: exportAllowed ? "pointer" : "not-allowed", marginLeft: "10px" }}
              onClick={() => {
                if (!exportAllowed) return;
                prepareCSV();
              }}
            />
          </Spin>
          <CSVLink data={CSVList} filename={"Nexus KPI Report.csv"} ref={csvLinkEl} />
          <ButtonFilled
            style={{ cursor: resolveAllowed ? "pointer" : "not-allowed" }}
            onClick={() => {
              if (!resolveAllowed) return;
              handleBulkResolve();
            }}
          >
            Resolve All
          </ButtonFilled>
        </div>
      </div>
      <br />
      <div>
        <Spin spinning={loading}>
          {report.data.length > 0 && (
            <StyledTable
              dataSource={sortRows(report.data).map((r) => ({ ...r, key: r.ID }))}
              columns={columns1}
              pagination={false}
              onRow={(record) => ({
                onMouseEnter: () => setHoveredRow(record?.key),
                onMouseLeave: () => setHoveredRow(null),
              })}
              onChange={(pagination, filters, sorter) => setTableSort({ field: sorter.field, order: sorter.order })}
            />
          )}
        </Spin>
      </div>

      <Modal
        open={filterModalOpen}
        onCancel={() => setFilterModalOpen(false)}
        width={900}
        destroyOnClose={false}
        footer={
          <ButtonFilled
            onClick={() => {
              const initial = {
                Name: "",
                FNAME: "",
                CustName: "",
                Shipper: "",
                duration: "current_month",
                daterange: rangeFor("current_month"),
                code: "",
                Status: "",
                REGNO: "",
              };
              filterform.resetFields();
              filterform.setFieldsValue(initial);
              setFilterValues(initial);
              setFilterCount(0);
              setCurrentPage(1);
              setFilterModalOpen(false);
            }}
          >
            {" "}
            Clear All{" "}
          </ButtonFilled>
        }
      >
        <Row>
          <Col xl={24} xs={{ span: 24, order: 2 }}>
            <div className="container_for_kpi_filter">
              <h6 className="Filter_for_clickablerow">Filter ({filterCount})</h6>
            </div>
          </Col>
        </Row>

        <Form form={filterform} layout="vertical" initialValues={getInitialValues()}>
          <Row gutter={16}>
            <Col xs={24} sm={24} md={6}>
              <Form.Item label="KPI Name" name="Name">
                <Input placeholder="" className="rounded-pill" onChange={(e) => handleFilterChange("Name", e.target.value)} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={6}>
              <Form.Item label="Consignee" name="FNAME">
                <Select
                  className="w-100"
                  showSearch
                  allowClear
                  onChange={(val) => handleFilterChange("FNAME", val)}
                  optionFilterProp="label"
                  options={consignees.map((f) => ({ label: f.name, value: f.name }))}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={6}>
              <Form.Item label="Consignor" name="CustName">
                <Select
                  className="w-100"
                  showSearch
                  allowClear
                  onChange={(val) => handleFilterChange("CustName", val)}
                  optionFilterProp="label"
                  options={consignors.map((f) => ({ label: f.name, value: f.name }))}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={6}>
              <Form.Item label="Transporter" name="Shipper">
                <Select
                  className="w-100"
                  showSearch
                  allowClear
                  onChange={(val) => handleFilterChange("Shipper", val)}
                  optionFilterProp="label"
                  options={transporterList?.map((item) => ({ label: item.Name, value: item.ID }))}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col xs={24} sm={24} md={6}>
              <Form.Item label="Duration" name="duration">
                <Select onChange={handleDurationChange}>
                  {Duration.map((item) => (
                    <Option key={item.value} value={item.value}>
                      {item?.label}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={6}>
              <Form.Item label="Date Range" name="daterange">
                <RangePicker
                  onChange={(dates) => {
                    if (!dates) return;
                    filterform.setFieldsValue({ duration: undefined });
                    handleFilterChange("daterange", dates);
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={6}>
              <Form.Item label="Consign Code" name="code">
                <Input placeholder="" className="rounded-pill" onChange={(e) => handleFilterChange("code", e.target.value)} />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col xs={24} sm={24} md={6}>
              <Form.Item label="Status" name="Status">
                <Select showSearch allowClear onChange={(val) => handleFilterChange("Status", val ?? "")}>
                  <Option value="0">UnResolved</Option>
                  <Option value="1">Resolved</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={6}>
              <Form.Item label="Vehicle No." name="REGNO">
                <Select
                  className="w-100"
                  showSearch
                  allowClear
                  onChange={(val) => handleFilterChange("REGNO", val)}
                  optionFilterProp="label"
                  options={vehicles.map((a) => ({ label: a.asset_name, value: a.asset_name }))}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>

      <UIModal
        width={600}
        open={resolveModal}
        onClose={handleresolveclose}
        closeButton={false}
        header={
          <Wrappercontainer>
            <Spin spinning={loading}>
              <Row>
                <Col xl={24} sm={24}>
                  <div className="modal_container_forfiltermenu">
                    <h4 className="flilter_five">{modalType === "view" ? "Comments" : "Resolving KPI"}</h4>
                  </div>
                  <hr />
                </Col>

                <Col xl={24} sm={24}>
                  {modalType === "view" ? (
                    <div>
                      <p>
                        <strong>{selectedRecord?.NAME}</strong> · Trip {selectedRecord?.tripcode} · {selectedRecord?.vehiclename}
                      </p>
                      {isResolved(selectedRecord || {}) ? (
                        <>
                          <p>Resolved by: {selectedRecord?.USERS || "-"}</p>
                          <p>On: {selectedRecord?.RESOLVEDON ? moment(selectedRecord.RESOLVEDON).format("Do MMM YYYY; hh:mm A") : "-"}</p>
                          <p>Comment: {selectedRecord?.MESSAGE || "-"}</p>
                        </>
                      ) : (
                        <p>This KPI alert has not been resolved yet.</p>
                      )}
                    </div>
                  ) : (
                    <>
                      <strong>Comments</strong>
                      <Input.TextArea
                        placeholder="Enter resolution comments"
                        rows={4}
                        maxLength={500}
                        onChange={(e) =>
                          setSelectedRecord((prev) => ({ ...prev, resolutionComment: e.target.value }))
                        }
                      />
                    </>
                  )}
                </Col>
              </Row>
            </Spin>
          </Wrappercontainer>
        }
        footer={
          modalType === "resolve" ? (
            <Wrappercontainer>
              <div key="footer" style={{ display: "flex", flexDirection: "row", justifyContent: "flex-end", gap: "15px" }}>
                <Buttontransparent className="cancel_btn_forpopup_two" onClick={handleresolveclose}>
                  Cancel
                </Buttontransparent>
                <ButtonFilled onClick={() => handleResolve()}>Resolve</ButtonFilled>
              </div>
            </Wrappercontainer>
          ) : null
        }
      />
      <ReusablePagination
        pageSize={pageSize}
        handlePageSizeChange={(v) => {
          setPageSize(v);
          setCurrentPage(1);
        }}
        currentPage={currentPage}
        total={report.total}
        handlePageChange={(page, size) => {
          setCurrentPage(page);
          setPageSize(size);
        }}
      />
    </Styledashboard>
  );
};

export default withNexusReportShell(KpiReports);
